"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JUMP_UNKNOW_URL = exports.JUMP_PATIENT_URL = exports.isQASeo = exports.MINI_PARAMS = void 0;
var miniprogramQuery_1 = require("./miniprogramQuery");
var searchParam_1 = require("./searchParam");
var getUrlParam_1 = require("./getUrlParam");
var seo_1 = require("../seo");
var MINI_PARAMS = function () {
    var info = (0, miniprogramQuery_1.getMiniprogramParams)(false);
    return {
        miniWexinAppId: info.get("miniWexinAppId"),
        openId: info.get("openId"),
        miniprogram: info.get("miniprogram"),
    };
};
exports.MINI_PARAMS = MINI_PARAMS;
var isQASeo = function () {
    return (0, seo_1.isJdhPage)() && window.location.pathname.startsWith("/qa/");
};
exports.isQASeo = isQASeo;
function JUMP_PATIENT_URL(options) {
    if (options === void 0) { options = {}; }
    // 解构options参数
    var _a = options || {}, _b = _a.protocol, protocol = _b === void 0 ? window.location.protocol : _b, _c = _a.domain, domain = _c === void 0 ? "m.healthjd.com" : _c, _d = _a.base, base = _d === void 0 ? "/s" : _d, _e = _a.router, router = _e === void 0 ? "" : _e;
    var _f = options.params, params = _f === void 0 ? {} : _f;
    // 根据不同的跳转 场景 配置参数
    // 拼接 跳转URL
    // 微信小程序参数
    params = __assign(__assign({}, params), (0, exports.MINI_PARAMS)());
    if ((0, exports.isQASeo)()) {
        params.fromSEOExpires = Math.floor((new Date().getTime() + 86400000) / 1000);
        // params.fromSEOExpires = Math.floor((new Date().getTime() + 600000) / 1000);
    }
    return "".concat(protocol, "//").concat(domain).concat(base).concat(router).concat((0, searchParam_1.searchParam)(params) ? "?".concat((0, searchParam_1.searchParam)(params)) : "");
}
exports.JUMP_PATIENT_URL = JUMP_PATIENT_URL;
var JUMP_UNKNOW_URL = function (url, options) {
    var origin = url.split("?")[0];
    var params = (0, getUrlParam_1.getUrlParam)(url);
    // 某个场景 带的参数
    Object.assign(params, options, (0, exports.MINI_PARAMS)());
    console.log("公共方法 JUMP_UNKNOW_URL：", "origin?".concat((0, searchParam_1.searchParam)(params)));
    return "".concat(origin, "?").concat((0, searchParam_1.searchParam)(params));
};
exports.JUMP_UNKNOW_URL = JUMP_UNKNOW_URL;
